import borders from "../../Theme/base/borders";
import colors from "../../Theme/base/colors";
// import typography from "../../Theme/base/typography";

const { border } = colors;
// const { baseProperties } = typography;
const { borderWidth } = borders;

export default {
  styleOverrides: {
    root: {
      //   fontSize: baseProperties.sm,
      color: border.main,
      height: "40px !important",
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `${borderWidth[1]} solid ${border.main}`,
      },

      "&:before": {
        borderColor: border.main,
        height: "40px !important",
      },

      "&:after": {
        borderColor: border.disabled,
        height: "40px !important",
      },
    },
  },
};
